module.exports = __webpack_public_path__ + "assets/img/banner-marcas-1920.jpg";